import React from 'react';

const PaperClipIcon = ({ size = 24, className = '', svgClassName = 'text-blue-600', style = {}, ...rest }) => {
  return (
    <div
      className={`rounded-lg w-fit cursor-pointer ${className}`}
      style={style}
      {...rest}
    >
      <svg
        viewBox="-3.6 -3.6 31.20 31.20"
        xmlns="http://www.w3.org/2000/svg"
        className={`${svgClassName}`}
        fill="none"
        stroke="currentColor"
        width={size}
        height={size}
      >
        <path
          d="M8.73,5.23,4.78,9.18a6.1,6.1,0,0,0,0,8.61h0a6.09,6.09,0,0,0,8.6,0l6.43-6.43a4,4,0,0,0,0-5.74h0a4.06,4.06,0,0,0-5.73,0L7.34,12.36a2,2,0,0,0,0,2.87h0a2,2,0,0,0,2.87,0l7-7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default PaperClipIcon;
